function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0{clip-path:url(#SVGID_2_);fill:#E6213C;}\r\n\t.st1{fill:#E6213C;}\r\n");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "SVGID_1_",
  x: 35,
  y: 35.5,
  width: 281,
  height: 281
}));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M305.2,251.2L305.2,251.2L234.9,189c-3.3-2.9-8.2-2.7-11.3,0.3l-11.6,11.6l-14.4-14.4l25.6-31.2 c23.9,12.4,54,8.6,74.1-11.5c15.8-15.8,21.5-37.7,17.2-58c-1.3-6-8.7-8.2-13-3.9l-27,27c-4.9,4.9-12.8,4.9-17.7,0 c-5.2-5.2-9.2-9.2-14.4-14.4c-4.9-4.9-4.9-12.8,0-17.7l27-27c4.3-4.3,2.1-11.7-3.9-13c-20.3-4.3-42.3,1.5-58,17.2 c-20.1,20.1-23.9,50.2-11.5,74.1l-31.2,25.6l-63.5-63.5l7-7c2.9-2.9,2.6-7.7-0.6-10.2l-36.4-30c-2.7-2.1-6.6-1.9-9.1,0.5 L43.1,62.9c-2.5,2.5-2.7,6.3-0.5,9.1l30,36.4c2.6,3.2,7.3,3.4,10.2,0.6l7-7l62.4,62.4L43.3,253.7c-10.3,8.1-11.2,23.3-2,32.6 c2.5,2.5,21.3,21.3,23.8,23.8c9.3,9.3,24.5,8.3,32.6-2l89.4-108.8l13.2,13.2l-12,12c-3.1,3.1-3.2,8.1-0.3,11.3l62.7,69.9 c12.4,13.8,33.7,14.2,46.7,1.2l9.1-9.1C319.7,284.9,319,263.5,305.2,251.2L305.2,251.2z M82.3,277.4c-4.6,0-8.2-3.7-8.2-8.2 c0-4.6,3.7-8.2,8.2-8.2c4.5,0,8.2,3.7,8.2,8.2C90.5,273.7,86.9,277.4,82.3,277.4L82.3,277.4z M82.3,277.4"
});

function SvgReparation01(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 350 350",
    style: {
      enableBackground: "new 0 0 350 350"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _ref3, /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _ref4)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReparation01);
export default __webpack_public_path__ + "static/media/reparation-01.ceec30b8.svg";
export { ForwardRef as ReactComponent };